import React, { useEffect, useRef, useState } from 'react'
import { url } from '../../../../configlink';
import axios from '../../../../api/axios';
import ReactQuill from "react-quill"; 
import "react-quill/dist/quill.snow.css";
import { useLocation } from 'react-router-dom';
import Quill from 'quill';
import { useSelector } from 'react-redux';

export default function PopupDetail() {

    let [popupData, setPopupData] = useState({
        title: '',
        category: {
            all: false,
            nih: false,
            nonNih: false,
            nucore: false,
			wps: false,
            specificCorp: []
        },
        fromDate: '',
        toDate: '',
        message: ''
    })

	let adminUser = useSelector((state) => state.userAdmin.userAdmin)

    let [showSpecificCorp, setShowSpecificCorp] = useState(false)

    console.log(popupData);

    let [companyData, setCompanyData] = useState([])

    useEffect(() => {
        getCompanyDrpDown()
    }, [])

    let loc = useLocation()
    let id = loc.search.split('=')[1]

    let [editMode, setEditMode] = useState(false)
      
      useEffect(() => {
        if(id){
            setEditMode(true)
          getData(id)
        }
      }, []);

      function getData(x){
          console.log(x);
          try {
            fetch(`${url}/api/admin/get_popups?id=${x}`, {
				credentials: 'include',
				headers: {
					'acgt-admin': adminUser
				},
            })
                .then((res) => res.json())
                .then((data) => {
                    console.log("fetched", data); 

                    let data2 = data.data[0]
                    console.log(JSON.parse(data2.category));
                    
                    setPopupData({
                        title: data2.title,
                        fromDate: data2.fromDate.split('T')[0],
                        toDate: data2.toDate.split('T')[0],
                        message: JSON.parse(data2.message),
                        category: JSON.parse(data2.category)
                    })   

                    setContent(JSON.parse(data2.message))

                    if(JSON.parse(data2.category).specificCorp.length > 0){
                        setShowSpecificCorp(true)
                        document.getElementById('tmpCorp').value = ''
                    }

                    
                })
                .catch(err => {
                    console.error(err);  
                })
        } catch (error) {
            console.error(error);
            
        }
        }


    const getCompanyDrpDown = async () => {
        try {
          const response = await axios.get(
            `${url}/api/admin/get_corporate_lists`, {
				withCredentials: true,
				headers: {
					'acgt-admin': adminUser
				},
            }
          );
    
        //   console.log(response.data);

        let sortedData = response.data.sort((a,b) => {
            if (a.CorporateName.toLowerCase() < b.CorporateName.toLowerCase()) return -1; 
            if (a.CorporateName.toLowerCase() > b.CorporateName.toLowerCase()) return 1;  
            return 0; 
        })
        // console.log("sorted",sortedData);
    
          setCompanyData(sortedData);
        } catch (error) {
          console.error(error);
        }
      };


        const [content, setContent] = useState();

    // Define toolbar options (without image)

    const [modules, setModules] = useState(null);

    useEffect(() => {
        import('quill-image-resize-module-react')
          .then((ImageResize) => {
            Quill.register('modules/imageResize', ImageResize.default);
            setModules({
                toolbar: [
                  [{ header: [1, 2, false] }],
                  ['bold', 'italic', 'underline'],
                  ['image'],
                //   [{ align: [] }]
                ],
                imageResize: {
                  displayStyles: {
                    backgroundColor: 'black',
                    border: 'none',
                    color: 'white',
                  },
                  modules: ['Resize'],
                },
              });
          })
          .catch((err) => console.error('Failed to load module', err));
      }, []);
    
    // const modules = {
    //     toolbar: [
    //       [{ header: [1, 2, false] }],
    //       ['bold', 'italic', 'underline'],
    //       ['image'],
    //     ],
    //     imageResize: {
    //       displayStyles: {
    //         backgroundColor: 'black',
    //         border: 'none',
    //         color: 'white',
    //       },
    //       modules: ['Resize'],
    //     },
    //   };

        let [isHTML, setIsHTML] = useState(false)

        let [errors, setErrors] = useState({})

    function validateData(){
        const popupErrors = {};
            if (!popupData.title) popupErrors.title = "Please Enter";
            if (!popupData.fromDate) popupErrors.fromDate = "Please Enter";
            if (!popupData.toDate) popupErrors.toDate = "Please Enter";
            if (!popupData.category.all && !popupData.category.nih && !popupData.category.nonNih && !popupData.category.nucore && !popupData.category.wps && popupData.category.specificCorp.length === 0 ){
                popupErrors.category = "Please select"
            }
            
            if (!popupData.message && content==='') popupErrors.message = "Please Enter";

            return popupErrors
    }   
    
    function submitPopupData(){
        const validate = validateData()

        console.log(validate);
    
        if (Object.keys(validate).length > 0) {
            setErrors(validate);
        } else {
            console.log('pass');

            let data = popupData

            if(isHTML){
                data.message = popupData.message
            }
            else if(!isHTML){
                if(content !==''){
                    data.message = content
                }
            }
            
            
            console.log('pass2', data);

            try {
                fetch(`${url}/api/admin/create_popup`, {
                    method:"POST",
                    credentials: 'include',
                    headers:{
						'Content-Type':'application/json',
						'acgt-admin': adminUser
                    },
                    body: JSON.stringify(data)
                })
                .then(res => res.json())
                .then(data => {
                    if(data.message === 'success'){
                        console.log('success');
                        alert("Success")
                        setPopupData({
                            title: '',
                            category: {
                                all: false,
                                nih: false,
                                nonNih: false,
                                nucore: false,
								wps: false,
                                specificCorp: []
                            },
                            fromDate: '',
                            toDate: '',
                            message: ''
                        })   
                        setContent('') 
                        window.close()             
                    }
                })
                .catch(err => {
                    console.error(err)
                }) 
                
                } catch (error) {
                console.error(error);
                } 
    
        }
    }

    function editPopupData(){
        const validate = validateData()

        console.log(validate);
    
        if (Object.keys(validate).length > 0) {
            setErrors(validate);
        } else {
            console.log('pass');

            let data = popupData

            if(isHTML){
                data.message = popupData.message
            }
            else if(!isHTML){
                if(content !==''){
                    data.message = content
                }
            }
            
            
            console.log('pass2', data);

            try {
                fetch(`${url}/api/admin/edit_popup?id=${id}`, {
                    method:"PUT",
                    credentials: 'include',
                    headers:{
						'Content-Type':'application/json',
						'acgt-admin': adminUser
                    },
                    body: JSON.stringify(data)
                })
                .then(res => res.json())
                .then(data => {
                    if(data.message === 'success'){
                        console.log('success');
                        alert("Success")              
                    }
                })
                .catch(err => {
                    console.error(err)
                }) 
                
                } catch (error) {
                console.error(error);
                } 
    
        }
    }

    

  return (
    <div  className='w-full p-8'>
        <style>
            {`
            .editor-container .ql-editor {
                min-height: 200px; 
                background-color: white;
            }
            `}
        </style>
        <div className='w-full'>
            <p className='text-2xl text-[var(---color-primary-purple)]'>Popup Details</p>
            <div className='mt-2 border-1 border-black px-4 py-4'>
                <div className='flex flex-col gap-[20px] pb-20'>
                    <div className='flex items-start gap-[10px] '>
                        <label className='w-[150px] text-xl'>Title:</label>
                        <div className='flex-1 flex flex-col'>
                            <input 
                                type="text" 
                                name="title" 
                                value={popupData.title}
                                className='border-1 h-[35px] px-2'
                                onChange={(e) => {
                                    setErrors({...errors, title:''})
                                    setPopupData({...popupData, title: e.target.value})}
                                } 
                            />
                            {errors.title && 
                            <span className='text-[14px] text-red-500 font-bold'>{errors.title}</span>
                            }
                        </div>
                    
                    </div>
                    <div className='flex items-start gap-[10px]'>
                        <label className='w-[150px] text-xl'>Apply to:</label>
                        <div className="flex flex-col gap-[10px] flex-1">
                            <div className='flex items-center gap-[10px]'>
                                <input 
                                    type="checkbox" 
                                    name="category" 
                                    className='w-[20px] h-[20px]' 
                                    checked={popupData.category.all === true}
                                    onChange={() => {
                                        setErrors({...errors, category:''})
                                        setPopupData({...popupData, category: {...popupData.category, all:!popupData.category.all}})}
                                    } 
                                />
                                <label>All</label>
                            </div>
                            <div className='flex items-center gap-[10px]'>
                                <input 
                                    type="checkbox" 
                                    name="category" 
                                    className='w-[20px] h-[20px]'
                                    checked={popupData.category.nih === true} 
                                    onChange={() => {
                                        setErrors({...errors, category:''})
                                        setPopupData({...popupData, category: {...popupData.category, nih:!popupData.category.nih}})}
                                    } 
                                />
                                <label>NIH</label>
                            </div>
                            <div className='flex items-center gap-[10px]'>
                                <input 
                                    type="checkbox" 
                                    name="category" 
                                    className='w-[20px] h-[20px]' 
                                    checked={popupData.category.nonNih === true} 
                                    onChange={() => {
                                        setErrors({...errors, category:''})
                                        setPopupData({...popupData, category: {...popupData.category, nonNih:!popupData.category.nonNih}})}
                                    } 
                                />
                                <label>Non-NIH (& Non-NU core) </label>
                            </div>
                            <div className='flex items-center gap-[10px]'>
                                <input 
                                    type="checkbox" 
                                    name="category" 
                                    className='w-[20px] h-[20px]' 
                                    checked={popupData.category.nucore === true} 
                                    onChange={() => {
                                        setErrors({...errors, category:''})
                                        setPopupData({...popupData, category: {...popupData.category, nucore:!popupData.category.nucore}})}
                                    } 
                                />
                                <label>NU Core</label>
                            </div>
							<div className='flex items-center gap-[10px]'>
                                <input 
                                    type="checkbox" 
                                    name="category" 
                                    className='w-[20px] h-[20px]' 
                                    checked={popupData.category.wps === true} 
                                    onChange={() => {
                                        setErrors({...errors, category:''})
                                        setPopupData({...popupData, category: {...popupData.category, wps:!popupData.category.wps}})   
                                    }
                                    } 
                                />
                                <label>WPS - Soft Launch</label>
                            </div>
                            <div className='flex items-center gap-[10px]'>
                                <input 
                                    type="checkbox" 
                                    name="category" 
                                    className='w-[20px] h-[20px]' 
                                    checked={popupData.category.specificCorp.length > 0 && showSpecificCorp === true} 
                                    onChange={() => setShowSpecificCorp(!showSpecificCorp)}
                                />
                                <label>Specific Corporates</label>
                            </div>
                            {showSpecificCorp === true && 
                            <div className='flex flex-col'>
                                <div className='flex items-center gap-[10px]'>
                                    <select 
                                        name="specificCorp"
                                        className='w-[300px] h-[35px] border-1'
                                        id='tmpCorp'
                                    >
                                    {companyData.map((data, i) => (
                                        <option value={JSON.stringify({id: data.CorporateId, name: data.CorporateName})} key={i}>
                                            {data.CorporateName}
                                        </option>
                                        ))}
                                    </select>
                                    <button 
                                    className='bg-[var(--color-primary-purple)] text-white px-2 py-1 rounded-md'
                                    onClick={() => { 
                                        let val = document.getElementById('tmpCorp').value
                                        console.log(val);
                                        setErrors({...errors, category:''})
                                        setPopupData({
                                            ...popupData,
                                            category: {
                                              ...popupData.category,
                                              specificCorp: [...popupData.category.specificCorp, JSON.parse(val)]
                                            }
                                          });
                                        
                                        document.getElementById('tmpCorp').value = ''
                                    
                                    }}>Add</button>
                                </div>
                                <div className=' mt-2 flex gap-[10px] flex-wrap'>
                                    {popupData.category.specificCorp.length > 0 && popupData.category.specificCorp.map((item, index) => (
                                        <button 
                                        key={index} 
                                        className='bg-gray-200 px-2 text-sm rounded-md'
                                        onClick={() => {
                                            setPopupData({
                                                ...popupData,
                                                category: {
                                                  ...popupData.category,
                                                  specificCorp: popupData.category.specificCorp.filter(x => x.id !== item.id)
                                                }
                                              })}
                                        }>
                                            {item.name} <span className='text-red-500 text-sm ml-1'>✖</span>
                                      </button>
                                    ))}
                                </div>
                            </div>
                            }
                            {errors.category && 
                                <span className='text-[14px] text-red-500 font-bold'>{errors.title}</span>
                            }
                        </div>
                    </div>
                    <div className='flex items-start gap-[10px] '>
                        <label className='w-[150px] text-xl'>From:</label>
                        <div className='flex flex-col'>
                            <input 
                                type="date" 
                                name="fromDate" 
                                value={popupData.fromDate}
                                className='w-[200px] border-1 h-[35px] px-2'
                                onChange={(e) => {
                                    setErrors({...errors, fromDate:''})
                                    setPopupData({...popupData, fromDate: e.target.value})}
                                } 
                            />
                             {errors.fromDate && 
                                <span className='text-[14px] text-red-500 font-bold'>{errors.fromDate}</span>
                            }   
                        </div>
                    </div>
                    <div className='flex items-start gap-[10px] '>
                        <label className='w-[150px] text-xl'>To:</label>
                        <div className='flex flex-col'>
                            <input 
                                type="date" 
                                name="toDate" 
                                value={popupData.toDate}
                                className='w-[200px] border-1 h-[35px] px-2'
                                onChange={(e) => {
                                    setErrors({...errors, toDate:''})
                                    setPopupData({...popupData, toDate: e.target.value})}
                                } 
                            />
                            {errors.toDate && 
                                <span className='text-[14px] text-red-500 font-bold'>{errors.toDate}</span>
                            }  
                        </div>
                    </div>
                    <div className='flex items-start gap-[10px] '>
                        <label className='w-[150px] text-xl'>Message</label>
                        <div className='flex flex-col flex-1 mr-5'>
                            <div className='flex'>
                                <button onClick={() => setIsHTML(false)} className={`w-[80px] ${isHTML ? 'bg-white text-[var(--color-primary-purple)]':'bg-[var(--color-primary-purple)] text-white'}`}>Text</button>
                                <button onClick={() => setIsHTML(true)} className={`w-[80px] ${isHTML ? 'bg-[var(--color-primary-purple)] text-white':'bg-white text-[var(--color-primary-purple)]'}`}>HTML</button>
                            </div>
                            {isHTML ? 
                            <div className='flex-1'>
                                <textarea 
                                value={popupData.message} 
                                onChange={(e) => {
                                    setErrors({...errors, message:'' })
                                    setPopupData({...popupData, message: e.target.value})} 
                                } 
                                placeholder='Message' name="message" rows={10} className='p-2 border-1 border-black w-full'></textarea>
                                
                            </div>
                            :
                            <div className='flex flex-col flex-1 editor-container'>
                                {modules ? 
                                <>
                                    <div dangerouslySetInnerHTML={{__html: `
                                        <style>
                                                                      
                                            .ql-align-left {
                                            text-align: left;
                                            }
                            
                                            .ql-align-center {
                                            text-align: center;
                                            }
                            
                                            .ql-align-right {
                                            text-align: right;
                                            }
                            
                                            .ql-align-justify {
                                            text-align: justify;
                                            }
                            
                                            .ql-align-left img {
                                            margin-left: 0;
                                            margin-right: auto;
                                            }
                            
                                            .ql-align-center img {
                                            margin-left: auto;
                                            margin-right: auto;
                                            }
                            
                                            .ql-align-right img {
                                            margin-left: auto;
                                            margin-right: 0;
                                            }
                                        </style>
                                `}}/>

                                        <ReactQuill className='editor-container'
                                        // formats={['header', 'bold', 'italic', 'underline', 'image']}
                                        theme="snow"
                                        value={content}
                                        onChange={setContent}
                                        // modules={modules} // Pass the modified toolbar
                                        modules={modules}
                                        placeholder="Message"
                                    />
                                </>
                               
                                :
                                <p>Loading..</p>
                                }
                                
                                <button onClick={() => {
                                    console.log(content);
                                    setErrors({...errors, message:'' })
                                    setPopupData({...popupData, message: content})
                                }} className='px-2 py-1 bg-red-300 mt-1 w-[150px]'>Convert</button>
                            </div>
                            }
                            {errors.message && 
                                <span className='mt-2 text-[14px] text-red-500 font-bold'>{errors.message}</span>
                            } 
                        </div>
                        
                    </div>
                    {editMode ?
                    <button onClick={editPopupData} className='px-4 py-2 bg-[var(--color-primary-purple)] text-white font-bold w-fit self-center'>Edit</button>
                    :
                    <button onClick={submitPopupData} className='px-4 py-2 bg-[var(--color-primary-purple)] text-white font-bold w-fit self-center'>Submit</button>
                    
                    }
                </div>
            </div>
        </div>
    </div>
  )
}
